import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appInnerTopMenu]',
})
export class InnerTopMenuDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
